/* Copyright (c) 2024 VMware, Inc. All rights reserved. VMware Confidential */
export * from "src/app/modules/shared/services/icon/icon.model";
export * from "src/app/modules/shared/services/icon/icon.service";
